import React from 'react'
import PropTypes from 'prop-types'
import TextFieldLib from '@material-ui/core/TextField'

function TextField({
  autoFocus,
  className,
  error,
  helperText,
  onChange,
  onBlur,
  onFocus,
  onKeyDown,
  onKeyUp,
  id,
  label,
  required,
  rows,
  type,
  value,
}) {
  return (
    <TextFieldLib
      autoFocus={autoFocus}
      className={className}
      fullWidth
      helperText={helperText}
      id={id}
      label={label}
      margin="normal"
      multiline={!!rows}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
      required={required}
      rows={rows}
      type={type}
      value={value}
      error={error}
      variant="outlined"
    />
  )
}

TextField.defaultProps = {
  autoFocus: false,
  // autoComplete: false,
  className: '',
  error: false,
  helperText: null,
  id: null,
  label: '',
  onChange: () => null,
  onBlur: () => null,
  onFocus: () => null,
  onKeyDown: () => null,
  onKeyUp: () => null,
  required: false,
  rows: null,
  type: 'off',
  value: '',
}

TextField.propTypes = {
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  id: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  rows: PropTypes.string,
  type: PropTypes.oneOf(['email', 'password', 'text', 'off']),
  value: PropTypes.node,
}

export default TextField
